import { render, staticRenderFns } from "./component-order-detaile-base.vue?vue&type=template&id=f3840f5c&scoped=true"
import script from "./component-order-detaile-base.vue?vue&type=script&lang=js"
export * from "./component-order-detaile-base.vue?vue&type=script&lang=js"
import style0 from "./component-order-detaile-base.vue?vue&type=style&index=0&id=f3840f5c&prod&lang=scss"
import style1 from "./component-order-detaile-base.vue?vue&type=style&index=1&id=f3840f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3840f5c",
  null
  
)

export default component.exports